@if (dropdownOptions) {
    <span>Show</span>
    <app-cerrix-select
        class="total-items-dropdown"
        [options]="dropdownOptions"
        [placeholder]="dropdownPlaceholder"
        [selectedIndex]="dropdownSelectedIndex"
        (selectionChange)="dropdownSelectionChange.emit($event)"
    ></app-cerrix-select>
    <span>{{ itemsText }}</span>
}
